// Module Federation runtime plugin: graceful degradation when the fe_common
// remote is unavailable (offline, DNS failure, timeout, unreachable manifest).
//
// Why this exists: the CommonHeader/CommonFooter are loaded via
// next/dynamic(..., { ssr: false }). When the remote is DOWN, MF's loadRemote
// rejects, and next/dynamic SWALLOWS the rejected loader and renders null — so
// neither the `loading` fallback nor the FederatedComponentBoundary fires, and
// the page shows no header/footer at all. This plugin's errorLoadRemote hook
// turns that load rejection into a RESOLVED fallback module, so next/dynamic
// renders the shared FallbackHeader/FallbackFooter instead of nothing.
//
// This file loads inside the federation bootstrap, so it must stay React-free:
// the fallbacks are pulled in via dynamic import() (a separate chunk fetched
// only on failure), never eagerly imported here. Loaded on both the browser and
// Node compiles, alongside mfRuntimeRemotesPlugin.js (see next.config.mjs).
import { mfOfflineHandling } from '@fe-toolkit/utility/modern/client'

export default () =>
  mfOfflineHandling({
    // Fail fast if the remote is slow so SSR/TTFB can't stall on a hung fetch.
    timeoutMs: 3000,
    // On load failure the shared full-nav fallbacks render in place of the
    // remote, receiving the same props the remote was given (e.g. username).
    // Relative paths (not the `@/` alias) keep resolution robust inside the
    // bundled runtime-plugin chunk.
    fallbacks: {
      'fe_common/components/CommonHeader': () =>
        import('../../components/fallbacks/FallbackHeader').then(
          m => m.default,
        ),
      'fe_common/components/CommonFooter': () =>
        import('../../components/fallbacks/FallbackFooter').then(
          m => m.default,
        ),
    },
  })
